import { useEffect } from "react";

import { useBulkAiAdvisorChat } from "@ryde/layout";
import { useAiAdvisor } from "@ryde/redux";

import { INVESTIGATION_AI_ENTITY } from "../investigation.constants";

/**
 * Ask-AI chat for the investigated ride. It is the same advisor chat the rides page uses, pinned to
 * this one ride's id instead of to a page's row selection — the overlay is mounted at the app root
 * and has no selection of its own.
 *
 * The stream is aborted on unmount: closing the investigation must not leave an answer streaming
 * into state nobody reads any more.
 */
export const useInvestigationAskAi = (rideId?: number) => {
  const { questionStream, question, cancelStream, isLoading, isStreaming } =
    useAiAdvisor(INVESTIGATION_AI_ENTITY);

  const chat = useBulkAiAdvisorChat({
    questionStream,
    question,
    entity: INVESTIGATION_AI_ENTITY,
    ids: rideId === undefined ? [] : [rideId],
  });

  useEffect(() => () => cancelStream(), [cancelStream]);

  return { ...chat, isLoading, isStreaming };
};
